import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateContentBuildId = Brand<number, 'TemplateContentBuildId'>;
export const TemplateContentBuildId = createBranded<TemplateContentBuildId>();
